export const listener = (eventName, ...args) => {
  console.log('socket eventName :>> ', eventName);
  console.log('args :>> ', args);
};
